export const seismicStandardOptions = [
  // DIN 4109 was a typo in the backend, but it would require a migration to change it
  // mapping it to DIN 4149 label to display correctly in the FE
  { value: 'DIN_4109', label: 'DIN 4149' },
  { value: 'SIA_261', label: 'SIA 261' },
  { value: 'DIN_EN_1998', label: 'DIN EN 1998 (EC 8)' },
]

export const groundTypeCombinationOptions = [
  { value: 'A-R', label: 'A-R' },
  { value: 'B-R', label: 'B-R' },
  { value: 'C-R', label: 'C-R' },
  { value: 'B-T', label: 'B-T' },
  { value: 'C-T', label: 'C-T' },
  { value: 'C-S', label: 'C-S' },
]

export const SIA_groundTypeCombinationOptions = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' },
  { value: 'E', label: 'E' },
]

export const seismicZoneOptions = [
  { value: 'Zone 1', label: 'Zone 1' },
  { value: 'Zone 2', label: 'Zone 2' },
  { value: 'Zone 3', label: 'Zone 3' },
]

export const SIA_seismicZoneOptions = [
  { value: 'Z_1_A', label: 'Z1a' },
  { value: 'Z_1_B', label: 'Z1b' },
  { value: 'Z_2', label: 'Z2' },
  { value: 'Z_3_A', label: 'Z3a' },
  { value: 'Z_3_B', label: 'Z3b' },
]

/**
 * Lookup table for S value (DIN EN 1998) based on spectral acceleration (S_aP,R in m/s²)
 * and ground type combination (Untergrundverhältnis).
 * Rows: spectral acceleration ranges
 * Columns: ground type combinations (A-R, B-R, C-R, B-T, C-T, C-S)
 */
export const DIN_EN_1998_S_LOOKUP: Record<string, Record<string, number>> = {
  '<=1.0': { 'A-R': 1.0, 'B-R': 1.25, 'C-R': 1.5, 'B-T': 1.05, 'C-T': 1.45, 'C-S': 1.3 },
  '1.0-2.0': { 'A-R': 1.0, 'B-R': 1.2, 'C-R': 1.3, 'B-T': 1.0, 'C-T': 1.25, 'C-S': 1.15 },
  '>2.0': { 'A-R': 1.0, 'B-R': 1.2, 'C-R': 1.15, 'B-T': 1.0, 'C-T': 1.1, 'C-S': 0.95 },
}

export function getDIN_EN_1998_S(
  spectralAcceleration: number,
  groundTypeCombination: string,
): number {
  const accel = Number(spectralAcceleration)
  let accelRange: string
  if (accel <= 1.0) accelRange = '<=1.0'
  else if (accel <= 2.0) accelRange = '1.0-2.0'
  else accelRange = '>2.0'

  return DIN_EN_1998_S_LOOKUP[accelRange][groundTypeCombination]
}
